import React from 'react';

import { ShareButton, Tappable } from '@common/ui/general';

function ShareProfile({ link }) {
  return (
    <ShareButton
      className="profile-sidebar__share"
      component={Tappable}
      shareLink={link}
      shareMessage="Checkout my profile on Scaler"
      onClick={() => window.trackGaEvent('ProfilePage', 'Social', 'share')}
    >
      Copy Profile Link
    </ShareButton>
  );
}

export default ShareProfile;
